import React from 'react'
import Nav from 'react-bootstrap/Nav';
import { useState } from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';

function EmployeeProjectNavbar() {
    const location = useLocation();
    const { employeeId, projectId } = useParams();

    return (
        <>
            <h5 className='mb-4'> Sample Project </h5>

            <Nav style={{ marginLeft: "-15px" }}>
                <Nav.Link
                    as={NavLink}
                    to={location?.pathname?.includes('/project/employeeproject') ? `/project/employeeproject/view/${projectId}/overview` : `/employees/view/${employeeId}/project/view/${projectId}/overview`}
                    style={({ isActive }) => ({
                        color: isActive ? 'black' : 'gray',
                        fontWeight: '500',
                    })}
                >
                    Overview
                </Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to={location?.pathname?.includes('/project/employeeproject') ? `/project/employeeproject/view/${projectId}/member` : `/employees/view/${employeeId}/project/view/${projectId}/member`}
                    style={({ isActive }) => ({
                        color: isActive ? 'black' : 'gray',
                        fontWeight: '500',
                    })}
                >
                    Member
                </Nav.Link>
                {console.log(location?.pathname)}
                <Nav.Link
                    as={NavLink}
                    to={location?.pathname?.includes('/project/employeeproject') ? `/project/employeeproject/view/${projectId}/files` : `/employees/view/${employeeId}/project/view/${projectId}/files`}
                    style={({ isActive }) => ({
                        color: isActive ? 'black' : 'gray',
                        fontWeight: '500',
                    })}
                >
                    Files
                </Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to={location?.pathname?.includes('/project/employeeproject') ? `/project/employeeproject/view/${projectId}/notes` : `/employees/view/${employeeId}/project/view/${projectId}/notes`}
                    style={({ isActive }) => ({
                        color: isActive ? 'black' : 'gray',
                        fontWeight: '500',
                    })}
                >
                    Notes
                </Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to={location?.pathname?.includes('/project/employeeproject') ? `/project/employeeproject/view/${projectId}/task` : `/employees/view/${employeeId}/project/view/${projectId}/task`}
                    style={({ isActive }) => ({
                        color: isActive ? 'black' : 'gray',
                        fontWeight: '500',
                    })}
                >
                    Task
                </Nav.Link>
                <Nav.Link
                    as={NavLink}
                    to={location?.pathname?.includes('/project/employeeproject') ? `/project/employeeproject/view/${projectId}/activity` : `/employees/view/${employeeId}/project/view/${projectId}/activity`}
                    style={({ isActive }) => ({
                        color: isActive ? 'black' : 'gray',
                        fontWeight: '500',
                    })}
                >
                    Activity
                </Nav.Link>
            </Nav>
        </>
    );
}

export default EmployeeProjectNavbar


